import { FC } from 'react';
import { Modal } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';

interface CantRideAloneModalProps {
  isOpen: boolean;
  close: () => void;
}
const CantRideAloneModal: FC<CantRideAloneModalProps> = ({ isOpen, close }) => (
  <Modal open={isOpen}>
    <Modal.Content>
      Riders under the age of 3 years old must be accompanied on their rides. Please call Safe Ride Support at
      844-HOP-SKIP if you have any questions.
    </Modal.Content>
    <Modal.Actions>
      <Button color="primary" onClick={close}>
        OK
      </Button>
    </Modal.Actions>
  </Modal>
);

export default CantRideAloneModal;
